module.exports = __webpack_public_path__ + "static/img/dev_apply.641066a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/document/dev_apply.png
// module id = 4Brt
// module chunks = 0